import {FunctionComponent} from "react";
import {HeaderOptions} from "../../../types/headerOptions";

interface props {
    tag: HeaderOptions
    big?: boolean,
    marginTop?: string
}

export const Heading: FunctionComponent<props> = ({children, tag, big=false, marginTop = 'mt-3'}) => {
    const Tag = tag as keyof JSX.IntrinsicElements;

    return (
        <Tag className={`font-bold ${big ? 'text-40' : 'text-3xl'} pr-24 text-black mb-1 inline-flex items-center gap-2 ${marginTop}`}>
            {children}
        </Tag>
    )
}